import { EntDirectoryInfoName } from '../../../../models/directoryInfoName'
import { EntInitialFilterName } from '../../../../models/filters/initialFilterName'
import { ResponseDataGet } from '../../../../models/responseDataGet'
import { agroApi } from '../../api'
import { Paths } from "../../../../paths";

export const executionStatusApi = agroApi.injectEndpoints({
  endpoints: builder => ({
	getExecutionStatusList: builder.query<
	  ResponseDataGet<EntDirectoryInfoName>,
	  EntInitialFilterName
	>({
	  query: filter => ({
		url: `${ Paths.handbooks.executionStatusType }/get-all`,
		method: 'POST',
		body: JSON.stringify(filter),
	  }),
	}),

	getExecutionStatusById: builder.query<ResponseDataGet<EntDirectoryInfoName>, number>({
	  query: id => ({
		url: `${ Paths.handbooks.executionStatusType }/${ id }`,
		method: 'GET',
	  }),
	}),

	addExecutionStatus: builder.mutation<
	  ResponseDataGet<EntDirectoryInfoName>,
	  EntDirectoryInfoName
	>({
	  query: body => ({
		url: `${ Paths.handbooks.executionStatusType }`,
		method: 'POST',
		body: JSON.stringify(body),
	  }),
	}),

	editExecutionStatus: builder.mutation<
	  ResponseDataGet<EntDirectoryInfoName>,
	  EntDirectoryInfoName
	>({
	  query: body => ({
		url: `${ Paths.handbooks.executionStatusType }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteExecutionStatus: builder.mutation<ResponseDataGet<EntDirectoryInfoName>, number>({
	  query: id => ({
		url: `${ Paths.handbooks.executionStatusType }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
})

export const {
  useAddExecutionStatusMutation,
  useDeleteExecutionStatusMutation,
  useEditExecutionStatusMutation,
  useLazyGetExecutionStatusListQuery,
} = executionStatusApi
